import { useQuerySnackbar } from '@explorer/hooks';
import { ControlCreateOrReactivateWizerRequest } from '@explorer/open-api-client';
import { useV1APIMutation } from '@explorer/query';
import { useIntl } from 'react-intl';

export const useMutationCreateWizerAccount = (params: {
  client_id: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}) => {
  const { client_id } = params;
  const { snackError, snackSuccess } = useQuerySnackbar();
  const intl = useIntl();

  return useV1APIMutation({
    mutationKey: ['v1ControlWebAdminCreateOrReactivateWizerAccount'],
    mutationFn(args: ControlCreateOrReactivateWizerRequest, client) {
      return client.v1ControlWebAdminCreateOrReactivateWizerAccountPost({
        ControlCreateOrReactivateWizerRequest: { ...args },
      });
    },
    onSuccess: () => {
      snackSuccess(intl.formatMessage({ id: 'sat.wizer.create-success' }));

      if (params.onSuccess) {
        params.onSuccess();
      }
    },
    explorerAPIOptions: {
      clientId: client_id,
      onError: (error) => {
        const response = error.error as Response | undefined;
        const message =
          response?.status === 409
            ? intl.formatMessage({ id: 'sat.wizer.create-error-conflict' })
            : intl.formatMessage({ id: 'sat.wizer.create-error' });

        snackError(message, error.error);

        if (params.onError) {
          params.onError(error);
        }
      },
    },
  });
};
